/* eslint-disable */
import { Grid, TextField, Typography, Box } from "@mui/material";
import { useState, useEffect } from "react";
import { getGestionAtencion } from "../../services/VerAnteojoArregloService";
import Message from "../../utils/Message";
//
// ###########################################################################
//
const DatosGestionAtencionCliente = (props) => {
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [data, setData] = useState({});
  //
  // ################################################################################
  //
  useEffect(() => {
    const loadDatosGestionAtencion = async () => {
      const response = await getGestionAtencion(props.idGestionAtencion, "header");

      if (response.ok) {
        setData(response.data.data);
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };
    loadDatosGestionAtencion();
  }, []);
  //
  // ################################################################################
  //
  return (
    <>
      {data && (
        <Box
          sx={{
            border: "1px solid LightGrey",
            borderRadius: "5px",
            p: 1,
            mb: 1,
          }}
        >
          <Grid container spacing={1} sx={{ mb: 1 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="h6" gutterBottom>
                Datos de Gestión de Atención y de Cliente
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2}>
              <TextField
                id="codigo"
                label="Código de Gestión de Atención"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="codigo"
                value={data.codigo ?? ""}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4}>
              <TextField
                id="descripcion_area"
                label="Sucursal"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="descripcion_area"
                value={data.descripcion_area ?? ""}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2} lg={2}>
              <TextField
                id="fecha_estado_gc"
                label="Fecha de registración"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="fecha_estado_gc"
                value={data.fecha_estado_gc ?? ""}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2} lg={2}>
              <TextField
                id="fecha_entrega"
                label="Fecha de entrega"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="fecha_entrega"
                value={data.fecha_entrega ?? ""}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={2} lg={2}>
              <TextField
                id="usuario_username"
                label="Vendedor"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="usuario_username"
                value={data.usuario_username ?? ""}
                variant="outlined"
              />
            </Grid>
          </Grid>

          <Grid container spacing={1} sx={{ mb: 1 }}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                id="nombreApellidoCliente"
                label="Nombre y Apellido"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="nombreApellidoCliente"
                value={(data.nombre_cliente ?? "") + " " + (data.apellido_cliente ?? "")}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                id="fechaNacimientoClienteEdad"
                label="Fecha de nacimiento - Edad"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="fechaNacimientoClienteEdad"
                value={(data.fecha_nac_cliente ?? "") + " - " + (data.edad_cliente ?? "") + " años"}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                id="email"
                label="email"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="email_cliente"
                value={data.email_cliente ?? ""}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                id="telefonosCliente"
                label="Teléfonos"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="telefonosCliente"
                value={(data.telefono_movil_cliente ?? "") + " " + (data.telefono_cliente ?? "")}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </Box>
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};
export default DatosGestionAtencionCliente;
